export enum CustomerNewsletterStatus {
    ALREADY_SUBSCRIBED = 'ACCOUNT_ALREADY_SUBSCRIBED',
    SUBSCRIBED = 'ACCOUNT_SUBSCRIBED',
    UNSUBSCRIBED = 'ACCOUNT_UNSUBSCRIBED',
}
